import * as React from "react";
const SvgCrossClientUnableToMatch = (props) => /* @__PURE__ */ React.createElement("svg", { width: 12, height: 12, viewBox: "0 0 12 12", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("rect", { x: 1, y: 5, width: 10, height: 2, rx: 1, fill: "#CED4DA" }));
export { SvgCrossClientUnableToMatch as ReactComponent };
